import realTitle from 'react-xocs/dist/xocs/references/title';
import Anchor from 'sd-ui/dist/commonjs/components/Anchor/Anchor';
import { createArticleLink } from '../../../utils/linkCreator';
import { createNavigationClickEventData, trackAdobeEvent } from '../../../utils/trackers/adobe';

export default function title(context, content, key) {
  const titleElement = realTitle(context, content, key);
  const onClick = () => {
    trackAdobeEvent('navigationClick', createNavigationClickEventData('reference-panel', 'article-name'));
  };
  const { refLink } = context.variables;
  if (refLink) {
    const articleLink = createArticleLink({
      pii: refLink.piiUnformatted,
      doi: refLink.crossRefDoi,
    });
    if (articleLink) {
      return (
        <Anchor
          href={articleLink}
          target="_blank"
          className="u-clr-grey7"
          onClick={onClick}
        >
          {titleElement}
        </Anchor>
      );
    }
  }
  return titleElement;
}

